import cn from 'classnames';
import { constVoid } from 'fp-ts/lib/function';
import * as React from 'react';
import { memo, useCallback } from 'react';
import { Mention, MentionsInput as MentionsInputComponent } from 'react-mentions';
import mentionStyle from './Mentions.module.scss';
import style from './NoteTextArea.module.scss';
var MentionsInput = MentionsInputComponent;
var NoteTextArea = memo(function (props) {
    var teamMembers = props.teamMembers, _a = props.isPending, isPending = _a === void 0 ? false : _a, note = props.value.note, _b = props.onChange, onChange = _b === void 0 ? constVoid : _b, _c = props.theme, theme = _c === void 0 ? {} : _c, _d = props.placeholder, placeholder = _d === void 0 ? 'Your note...' : _d;
    var handleMount = useCallback(function (el) {
        if (el && el instanceof HTMLElement) {
            el.focus();
        }
    }, []);
    var handleTextChange = useCallback(function (
    // tslint:disable-next-line: variable-name
    _event, newValue, 
    // tslint:disable-next-line: variable-name
    _newPlainTextValue, mentions) {
        onChange({
            note: newValue,
            mentions: mentions.map(function (m) { return Number(m.id); }),
        });
    }, [onChange]);
    return (React.createElement(MentionsInput, { inputRef: handleMount, placeholder: placeholder, value: note, "data-gramm": "false", classNames: {
            mentions: style.text,
            mentions__control: cn(style.text__control, theme.control),
            mentions__highlighter: cn(style.text__highlighter, theme.highlighter),
            mentions__input: cn('form-control', style.text__input, theme.input),
            mentions__suggestions__list: 'dropdown-menu show',
            mentions__suggestions__item: 'dropdown-item',
            'mentions__suggestions__item--focused': 'dropdown-item-hover',
        }, disabled: isPending, onChange: handleTextChange },
        React.createElement(Mention, { trigger: "@", className: mentionStyle.mention, data: formatMemberMentions(teamMembers) })));
});
function formatMemberMentions(members) {
    return members.map(function (m) { return ({
        id: m.id,
        display: m.name,
    }); });
}
export default NoteTextArea;
//# sourceMappingURL=NoteTextArea.js.map